<template>
  <div class="BaseHistory">
    <v-data-table
        dense
        :headers="getColumns"
        :items="itemList"
        class="elevation-1"
        :options.sync="options"
        @update:options="updateOptions"
        :server-items-length="totalRecords"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': [10, 15, 20, 50, 100]
        }"
        fixed-header
        @click:row="onClickRow"
        :height="windowHeight"
        group-by="date_only"
    >
      <template v-slot:top>
        <v-toolbar dense class="mt-2 pt-1 mb-2" elevation="1" color="gridtoolbar">
          <v-text-field
              dark
              v-model="searchTerm"
              label="Search"
              class="mx-4"
              clearable
              @input="onUpdateSearchTerm"
          ></v-text-field>
          <v-checkbox
              dark
              class="mt-4"
              :input-value="restorePanel"
              @change="onSwitchChange"
              off-icon="mdi-arrow-collapse-left"
              on-icon="mdi-arrow-collapse-right"
          >
          </v-checkbox>
        </v-toolbar>
      </template>
      <template v-slot:group.header="{items, isOpen, toggle}">
        <th colspan="5">
<!--          <v-icon @click="toggle"-->
<!--            >{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}-->
<!--          </v-icon>-->
          {{ items[0].date_only | moment("DD.MM.YYYY")}}
        </th>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon v-if="selectedItemList.includes(item)">
          mdi-arrow-right-bold
        </v-icon>
      </template>
      <template v-slot:item.time_only="{ item }">
        {{ item.history_date | moment("hh:mm:ss") }} {{ item.history_user__username }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {mapFields} from "vuex-map-fields";
import {debounce} from "debounce";
import BaseFormatDateField from "@/components/BaseFormatDateField";

export default {
  name: 'BaseHistoryDetail',
  props: ['storeDocItemId', 'restorePanel', 'activeHistoryId', 'windowHeight'],

  components: {
    BaseFormatDateField,
  },

  computed: {
    ...mapGetters('BaseHistoryDetail', ['getColumns']),
    ...mapFields('BaseHistoryDetail', ['wsUrl', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm', 'isAlive',
      'month_left', 'month_right']),
  },

  methods: {
    ...mapActions('BaseHistoryDetail', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems']),
    ...mapMutations('BaseHistoryDetail', ['updateFilters']),

    updateOptions() {
      // console.log('updateOptions')
      this.fetchItemList()
    },
    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm')
      this.updateFilters({
        store_doc_id: this.storeDocItemId,
        month_left: this.month_left,
        month_right: this.month_right
      })
      this.options.page = 1
      this.fetchItemList()
    }, 800),
    onSwitchChange(event) {
      console.log('onSwitchChange', event)
      this.$emit('update:restorePanel', event)
    },
    onClickRow(item, event) {
      console.log('onSelectRow', item)
      this.selectedItemList = [item]
      this.$emit('update:activeHistoryId', item.history_id)
    },
  },
  created() {
    // this.wsUrl = this.wsDetail
  },
  mounted() {
    this.updateFilters({store_doc_id: this.storeDocItemId, month_left: this.month_left, month_right: this.month_right})
    // this.$store.commit('updateStoreDocItemId', this.storeDocItemId)
    this.fetchItemList();
  },
  date() {
    return {}
  },
}
</script>
